import { render, staticRenderFns } from "./configCard.vue?vue&type=template&id=3f856318&scoped=true"
import script from "./configCard.vue?vue&type=script&lang=js"
export * from "./configCard.vue?vue&type=script&lang=js"
import style0 from "./configCard.vue?vue&type=style&index=0&id=3f856318&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f856318",
  null
  
)

export default component.exports